import React from 'react';

interface ISortIconProps {
  style?: any;
}

export const SortIcon:React.FC<ISortIconProps> = (props: ISortIconProps) => {
  return (
    <svg width="31.000000000000004" height="23" xmlns="http://www.w3.org/2000/svg">
      <g>
        <title>background</title>
        <rect fill="none" id="canvas_background" height="25" width="33" y="-1" x="-1"/>
      </g>
      <g>
        <title>Layer 1</title>
        <path fill="#ffffff" stroke="null" id="svg_3" d="m28.24084,1.70953l-25.45214,0c-1.32847,0 -1.55117,0.74787 -1.55117,1.45621c0,0.7084 0.2227,1.10839 1.55117,1.10839l25.45214,0c1.32847,0 1.17173,-0.66086 1.17173,-1.36926c0,-0.70834 0.15674,-1.19534 -1.17173,-1.19534z"/>
        <path id="svg_6" d="m30.00031,24.4881l-7.93591,0c-0.82843,0 -1.49969,0.67126 -1.49969,1.49969c0,0.82849 0.67126,1.49969 1.49969,1.49969l7.93591,0c0.82843,0 1.49969,-0.6712 1.49969,-1.49969c0,-0.82843 -0.67126,-1.49969 -1.49969,-1.49969z"/>
        <path fill="#ffffff" stroke="null" id="svg_12" d="m24.154379,6.839946l-21.682382,0c-1.131708,0 -1.321424,0.74787 -1.321424,1.45621c0,0.7084 0.189716,1.10839 1.321424,1.10839l21.682382,0c1.131708,0 0.998183,-0.66086 0.998183,-1.36926c0,-0.70834 0.133525,-1.19534 -0.998183,-1.19534z"/>
        <path fill="#ffffff" stroke="null" id="svg_13" d="m21.3214,12.31819l-19.01214,0c-0.99233,0 -1.15869,0.74787 -1.15869,1.45621c0,0.7084 0.16636,1.10839 1.15869,1.10839l19.01214,0c0.99233,0 0.87525,-0.66086 0.87525,-1.36926c0,-0.70834 0.11708,-1.19534 -0.87525,-1.19534z"/>
        <path fill="#ffffff" stroke="null" id="svg_14" d="m18.32177,17.4486l-16.18482,0c-0.84476,0 -0.98638,0.74787 -0.98638,1.45621c0,0.7084 0.14162,1.10839 0.98638,1.10839l16.18482,0c0.84476,0 0.74509,-0.66086 0.74509,-1.36926c0,-0.70834 0.09967,-1.19534 -0.74509,-1.19534z"/>
      </g>
    </svg>
  )
}